<template>
  <!-- @mouseleave="toggleOverlay(false)" -->
  <div
    @click="overlayClickHandler"
    :class="['overlay', `overlay__${overlay.type}`]"
  >
    <transition name="fade-scaled" appear>
      <a
        v-if="showclose"
        href="#p"
        @click.prevent="toggleOverlay(false)"
        :class="['closebtn', 'btn-white']"
      ></a>
    </transition>
    <component :is="overlay.type"></component>
    <!-- <overlay-menu></overlay-menu> -->
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";

import Search from "@/components/search/Search.vue";
import OverlayMenu from "@/components/OverlayMenu.vue";
export default {
  data() {
    return {
      showclose: false
    };
  },
  components: {
    OverlayMenu,
    Search
  },
  deactivated() {
    console.log("overlay activated");
    this.showclose = false;
  },
  activated() {
    console.log("overlay activated");
    setTimeout(
      function() {
        this.showclose = true;
      }.bind(this),
      800
    );
  },
  detroyed() {
    console.log("overlay destroyed");
    this.showclose = false;
  },
  mounted() {},
  computed: {
    ...mapState(["overlay"])
  },
  methods: {
    ...mapActions(["toggleOverlay"]),
    overlayClickHandler() {
      if (this.overlay.type === "overlay-menu") {
        this.toggleOverlay(false);
      }
    }
  }
};
</script>
<style lang="stylus" scoped>
.overlay
	position fixed
	top 0
	height 85vh
	width 100%
	background c_primary
	z-index 1002
	.closebtn
		position absolute
		top 20px
		right 20px
	&__search
		top 0
		height 100%
		overflow auto
		padding-bottom 120px
		.closebtn
			right 20px
	&--wrap
		display flex
		flex-direction row
		align-items center
		justify-content space-between
		height 100%
		width 100%
		& > *
			&:first-child
				flex 100%
			&:last-child
				display none
			+above(415px)
				height 100%
				flex 0 0 50%
				&:last-child
					display flex
	/*
		Left side of menu
	*/
	&__left
		// background rgba(red, 0.2)
		padding-top 30vh
	&--logo
		position relative
		width 80%
		border-bottom 1px solid c_lt_blue
		svg
			position absolute
			bottom 2vh
			right 0
			max-width 165px
			fill #fff
	&--root
		width 80%
		display flex
		flex-direction column
		align-items flex-end
		a
			position relative
			display block
			color rgba(#fff, 0.7)
			font-size responsive 24px 30px
			line-height 1
			padding 10px 0
			will-change color
			transition color 0.3s ease-out
			// border 1px solid #212121
			span, i
				display inline-block
				vertical-align middle
				line-height 1
			i
				font-size 55%
				top 52%
				right -45px
				position absolute
				transform translate(0, -50%)
				will-change transform
			&.active
				color rgba(#fff, 1)
			hoverize(#fff, color)

	/*
		Right side of menu
	*/
	&__right
		// background rgba(green, 0.2)
		display flex
		justify-content flex-start
		align-items center
	&--list
		text-align left
    &--items
      margin-top 12px
		&--category
			&:not(:last-child)
				padding-bottom 12px
				margin-bottom 12px
				position relative
				&:after
					content ''
					height 1px
					width 16%
					background c_lt_blue
					position absolute auto auto 0 0
			.category-link
				color c_lt_blue
				text-transform uppercase
				font-size responsive 18px 22px
				display block
				font-weight 400
				+desktop()
					transition color 0.3s ease-out
					&:hover
						color lighten(c_lt_blue, 10)
			.item-link
				font-size responsive 13px 15px
				color rgba(#fff, 0.8)
				display block
				line-height 1
				margin-bottom 2px
				+desktop()
					transition color 0.3s ease-out
					&:hover
						color rgba(#fff, 1)
</style>
